export default __webpack_public_path__ + "static/spinnerPrimary-cda11cfc47b4ad034f2a5a872213ce15.gif";